function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m193.41 212.881c0-58.174 47.328-105.502 105.502-105.502l17.244-13.872-17.244-16.128c-74.716 0-135.502 60.786-135.502 135.502s60.786 135.502 135.502 135.502l17.244-17.424-17.244-12.576c-58.174 0-105.502-47.328-105.502-105.502",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m30.207 212.881c0-58.174 47.328-105.502 105.502-105.502l13.067-13.872-13.067-16.128c-74.716 0-135.502 60.786-135.502 135.502 0 69.646 52.819 127.179 120.502 134.667v84.226h-40.458v30h40.458v50.226h15l9.09-65.38-9.09-128.237c-58.174 0-105.502-47.328-105.502-105.502z",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271.211 212.881-15.211-10.7-14.789 10.7c0 58.174-47.328 105.502-105.502 105.502v193.617h15v-50.226h40.457v-30h-40.457v-84.226c67.683-7.488 120.502-65.021 120.502-134.667z",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
})), /*#__PURE__*/React.createElement("path", {
  d: "m271.211 212.881c0-74.716-60.786-135.502-135.502-135.502v30c58.174 0 105.502 47.328 105.502 105.502z",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
}), /*#__PURE__*/React.createElement("path", {
  d: "m193.41 212.881h-30c0 74.716 60.786 135.502 135.502 135.502v-30c-58.174 0-105.502-47.328-105.502-105.502z",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
}), /*#__PURE__*/React.createElement("path", {
  d: "m401.175 0v30h59.405l-77.095 77.095c-23.197-18.583-52.607-29.717-84.573-29.717v30c58.174 0 105.502 47.328 105.502 105.502s-47.328 105.502-105.502 105.502v30c74.716 0 135.502-60.786 135.502-135.502 0-31.966-11.133-61.375-29.716-84.573l77.095-77.095v59.405h30v-110.617z",
  stroke: "black",
  strokeWidth: 2,
  fill: "#fed300"
}));

var SvgGender = function SvgGender(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender.506d2a1b.svg";
export { ForwardRef as ReactComponent };